<!-- Button -->
<button mat-icon-button [matMenuTriggerFor]="userActions">
    <span class="relative">
        @if (showAvatar && user?.avatar) {
            <img
                class="h-7 w-7 rounded-full"
                [src]="user.avatar"
                [alt]="
                    (user?.firstName || '') + ' ' + (user?.lastName || '')
                        | translate
                "
            />
        }
        @if (!showAvatar || !user?.avatar) {
            <mat-icon [svgIcon]="'heroicons_outline:user-circle'"></mat-icon>
        }
        @if (profileStatusIcon) {
            <span
                class="absolute -bottom-0.5 -right-0.5 h-3 w-3 rounded-full border-2 border-white"
                [class.bg-red-500]="profileStatusIcon === 'error'"
                [class.bg-amber-500]="profileStatusIcon === 'pending'"
                [class.bg-green-500]="profileStatusIcon === 'check_circle'"
            ></span>
        }
    </span>
</button>

<mat-menu [xPosition]="'before'" #userActions="matMenu">
    <button mat-menu-item>
        <span class="flex flex-col leading-none">
            <span>{{ 'user.Signed in as' | translate }}</span>
            <span class="mt-1.5 text-md font-medium">{{ user?.email }}</span>
        </span>
    </button>
    <mat-divider class="my-2"></mat-divider>
    @if (currentRole === roles.FilmMaker) {
        <button mat-menu-item (click)="navigateToProfile()">
            <mat-icon [svgIcon]="'heroicons_outline:user-circle'"></mat-icon>
            <span class="flex items-center gap-2">
                {{ 'navigation.My Profile' | translate }}
                @if (profileStatusIcon) {
                    <mat-icon
                        class="text-base"
                        [class]="profileStatusIconClass"
                        style="font-size: 16px; width: 16px; height: 16px"
                        >{{ profileStatusIcon }}</mat-icon
                    >
                }
            </span>
        </button>
    }
    @if (currentRole === roles.FilmMaker && features.referral) {
        <button mat-menu-item (click)="navigateToReferAndEarn()">
            <mat-icon> card_giftcard</mat-icon>
            <span>{{ 'referAndEarn.Refer & Earn' | translate }}</span>
        </button>
    }
    @if (currentRole === roles.FilmMaker) {
        <button mat-menu-item (click)="changePassword()">
            <mat-icon [svgIcon]="'heroicons_outline:lock-closed'"></mat-icon>
            <!-- Show Create Password if user is not created password -->
            @if (!user?.isPasswordSet) {
                <span>{{ 'filmMakerSignIn.Create Password' | translate }}</span>
            } @else {
                <span>{{ 'filmMakerSignIn.Change Password' | translate }}</span>
            }
        </button>
    }
    <mat-divider class="my-2"></mat-divider>
    <button mat-menu-item (click)="signOut()">
        <mat-icon
            [svgIcon]="'heroicons_outline:arrow-right-on-rectangle'"
        ></mat-icon>
        <span>{{ 'user.Sign out' | translate }}</span>
    </button>
</mat-menu>
